import { createSlice } from "@reduxjs/toolkit";
import { EsicMonthlyContributionState } from "./esicMonthlyContributionTypes";
import {
  createEsicMonthlyContribution,
  fetchEsicMonthlyContributionList,
  fetchEsicMonthlyContributionById,
  updateEsicMonthlyContribution,
  deleteEsicMonthlyContribution,
} from "./esicMonthlyContributionAction";

const initialState: EsicMonthlyContributionState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
};

const esicMonthlyContributionSlice = createSlice({
  name: "esicMonthlyContribution",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Create
    builder.addCase(createEsicMonthlyContribution.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createEsicMonthlyContribution.fulfilled, (state, action) => {
      state.loading = false;
      state.list.push({
        contribution_id: action.payload.id,
        esic_emp_id: 0,
        salary_month: "",
        gross_wages: 0,
        esic_wages: 0,
        employee_contribution: 0,
        employer_contribution: 0,
        payment_status: "Pending",
        payment_date: null,
        challan_number: null,
      });
    });
    builder.addCase(createEsicMonthlyContribution.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Get All
    builder.addCase(fetchEsicMonthlyContributionList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchEsicMonthlyContributionList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    });
    builder.addCase(fetchEsicMonthlyContributionList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Get By Id
    builder.addCase(fetchEsicMonthlyContributionById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchEsicMonthlyContributionById.fulfilled, (state, action) => {
      state.loading = false;
      state.selected = action.payload;
    });
    builder.addCase(fetchEsicMonthlyContributionById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Update
    builder.addCase(updateEsicMonthlyContribution.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateEsicMonthlyContribution.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateEsicMonthlyContribution.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Delete
    builder.addCase(deleteEsicMonthlyContribution.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteEsicMonthlyContribution.fulfilled, (state, action) => {
      state.loading = false;
      state.list = state.list.filter(
        (item) => item.contribution_id !== (action.meta.arg as number)
      );
    });
    builder.addCase(deleteEsicMonthlyContribution.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default esicMonthlyContributionSlice.reducer;
